function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:2;stroke-miterlimit:10;}\r\n");
var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "XMLID_26_"
}, /*#__PURE__*/React.createElement("polygon", {
  id: "XMLID_19_",
  className: "st0",
  points: "65.5,14.9 21.4,43.1 24.9,93.7 68.6,115.1 108,91.8 108,41.3  "
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_27_",
  className: "st0",
  d: "M66,38L41.4,80.4c-0.1,0.2,0,0.6,0.3,0.6l52,0.8c0.3,0,0.5-0.3,0.3-0.6L66.7,38 C66.5,37.8,66.2,37.8,66,38z"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_29_",
  className: "st0",
  d: "M66.7,38l39.2,3.1c1.3,0.1,2.2,1.5,1.7,2.7l-13.8,38"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_28_",
  className: "st0",
  d: "M66,14.9V38l-43.5,4.9c-0.3,0.1-0.4,0.4-0.2,0.6l19.4,37.4L25.5,93.7"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_47_",
  className: "st0",
  d: "M108.5,91.8l-14.7-10l-23.9,32.3c-0.3,0.5-1,0.5-1.4,0L41.7,80.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_46_",
  className: "st0",
  d: "M41.7,80.9"
}), /*#__PURE__*/React.createElement("path", {
  id: "XMLID_30_",
  className: "st0",
  d: "M93.2,81.8"
}));
function SvgD20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 130 130",
    style: {
      enableBackground: "new 0 0 130 130"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgD20);
export default __webpack_public_path__ + "static/media/d20.5cab35800a50076e811f0ba8c6a5dec8.svg";
export { ForwardRef as ReactComponent };